import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

// viewBox="0 0 29.04492 27.43504"
const ArrowUp = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 8" width={size} height={size}>
      <title>{iconTitle}</title>
      <g id="Welcome" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="reikningur" transform="translate(-1034.000000, -605.000000)" fill={iconColor}>
          <path d="M1042.49987,605 L1034.32686,612.295321 C1033.91866,612.658863 1033.88872,613.279136 1034.26,613.678934 C1034.63027,614.079711 1035.26104,614.109108 1035.66924,613.745567 L1042.49987,607.648657 L1049.33051,613.745567 C1049.73771,614.109108 1050.37048,614.079711 1050.74075,613.678934 C1051.11103,613.279136 1051.08108,612.658863 1050.67388,612.295321 L1042.49987,605 Z" />
        </g>
      </g>
    </svg>
  );
};

ArrowUp.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

ArrowUp.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};
export default withTheme(ArrowUp);
